import SubthemeMultiSelect from "@app/shared/components/Theme/SubthemeMultiSelect";
import { ThemeMultiSelect } from "@app/shared/components/Theme/ThemeMultiSelect";
import { UserMultiSelect } from "@app/shared/components/UserMultiSelect";
import { FlexRow } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import {
    type Dispatch,
    type FC,
    type PropsWithChildren,
    type SetStateAction,
} from "react";
import { useTranslation } from "react-i18next";
import { keys, RESOURCE_NAME } from "./i18n";

export const AssigneeFilterChip: FC<{
    value: (string | null)[];
    onValueChange: (val: (string | null)[]) => void;
    searchFilter?: string;
    onSearchFilterChange?: Dispatch<SetStateAction<string | undefined>>;
    includeNone?: boolean;
}> = ({
    value,
    onValueChange,
    searchFilter,
    onSearchFilterChange,
    includeNone,
}) => {
    const { t } = useTranslation(RESOURCE_NAME);
    return (
        <UserMultiSelect
            filterLabel={t(keys.assignee_label)}
            value={value}
            onValueChange={onValueChange}
            searchFilter={searchFilter}
            onSearchFilterChange={onSearchFilterChange}
            isFilter
            includeNone={includeNone}
        />
    );
};

export const ThemeFilterChip: FC<{
    value: (string | null)[];
    onValueChange: (value: (string | null)[]) => void;
    searchFilter?: string;
    onSearchFilterChange?: Dispatch<SetStateAction<string | undefined>>;
}> = ({ value, onValueChange, searchFilter, onSearchFilterChange }) => {
    return (
        <ThemeMultiSelect
            hasPortal
            values={value}
            onValuesChange={onValueChange}
            searchFilter={searchFilter}
            onSearchFilterChange={onSearchFilterChange}
        />
    );
};

export const SubThemeFilterChip: FC<{
    value: (string | null)[];
    onValueChange: (value: (string | null)[]) => void;
    searchFilter?: string;
    onSearchFilterChange?: Dispatch<SetStateAction<string | undefined>>;
}> = ({ value, onValueChange, searchFilter, onSearchFilterChange }) => {
    return (
        <SubthemeMultiSelect
            hasPortal
            values={value}
            onValuesChange={onValueChange}
            searchFilter={searchFilter}
            onSearchFilterChange={onSearchFilterChange}
        />
    );
};

export const FilterChips: FC<PropsWithChildren> & {
    AssigneeFilterChip: typeof AssigneeFilterChip;
    ThemeFilterChip: typeof ThemeFilterChip;
    SubThemeFilterChip: typeof SubThemeFilterChip;
} = ({ children }) => {
    const { t } = useTranslation(RESOURCE_NAME);
    return (
        <FlexRow wrap="wrap" gap="2" w="full" alignItems="center">
            <Text variant="caption-bold">{t(keys.filters_label)}</Text>
            {children}
        </FlexRow>
    );
};

FilterChips.AssigneeFilterChip = AssigneeFilterChip;
FilterChips.ThemeFilterChip = ThemeFilterChip;
FilterChips.SubThemeFilterChip = SubThemeFilterChip;
